// import { useEffect, useState, useRef } from "react"; // No longer needed for local state management of content/style
import { TextNodeData } from "../../types";
import ConfigBoxToolbar from "../../components/shared/ConfigBoxToolbar";

interface TextConfigBoxProps {
  data: TextNodeData; // data might be used by ConfigBoxToolbar or future additions
  onUpdate?: (data: Partial<TextNodeData>) => void; // Kept for future use or if ConfigBoxToolbar needs it
  onDelete?: () => void;
  onDuplicate?: () => void;
  onDetachFromGroup?: () => void;
  isAdvancedMode?: boolean;
  isDisabled?: boolean; // This might disable the ConfigBoxToolbar actions
  portalRoot?: HTMLElement | null; // Kept for ConfigBoxToolbar if it uses portals
}

// TEXT_STYLES and TEXT_COLORS are removed as styling is handled by the rich text editor.

export default function TextConfigBox({
  // data, // data is implicitly used by onUpdate if it were to update other props
  // onUpdate, // onUpdate is not directly used by this simplified version for content/style
  onDelete,
  onDuplicate,
  onDetachFromGroup,
  isAdvancedMode = false,
  // isDisabled = false, // isDisabled might be used by ConfigBoxToolbar
}: TextConfigBoxProps) {
  // Content, textStyle, and textColor are now managed by the on-canvas Lexical editor.
  // The useEffect hooks for managing and updating these states are removed.

  return (
    <div className="space-y-3 relative">
      <ConfigBoxToolbar
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        onDetachFromGroup={onDetachFromGroup}
        isAdvancedMode={isAdvancedMode}
        // Potentially pass isDisabled to ConfigBoxToolbar if its actions should be disabled
      />

      {/* Content editing UI (textarea, style, color pickers) is removed. */}
      {/* Editing is now done directly on the TextNode using Lexical. */}
      {/* This ConfigBox can remain for common node operations like delete, duplicate, etc. */}
      {/* Or provide other non-content related configurations if any. */}
    </div>
  );
}
